export const themeBasedAccordion = (theme) => ({
  ["-bs-accordion-color"]: theme === "light" ? "rgba(0,0,0,.9)" : "rgba(255,255,255,.9)",
  ["--bs-accordion-bg"]: "none",
  ["--bs-accordion-transition"]:
    "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease",
  ["--bs-accordion-border-color"]: "var(--bs-border-color)",
  ["--bs-accordion-border-width"]: "var(--bs-border-width)",
  ["--bs-accordion-border-radius"]: "var(--bs-border-radius)",
  ["--bs-accordion-inner-border-radius"]: "calc(var(--bs-border-radius) - (var(--bs-border-width)))",
  ["--bs-accordion-btn-padding-x"]: "1.25rem",
  ["--bs-accordion-btn-padding-y"]: "1rem",
  ["--bs-accordion-btn-color"]: theme === "light" ? "rgba(0,0,0,.9)" : "rgba(255,255,255,.9)",
  ["--bs-accordion-btn-bg"]: "none",
  ["--bs-accordion-btn-icon"]: `url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23${theme === "light" ? "212529" : "ffffff"}%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e")`,
  ["--bs-accordion-btn-icon-width"]: "1.25rem",
  ["--bs-accordion-btn-icon-transform"]: "rotate(-180deg)",
  ["--bs-accordion-btn-icon-transition"]: "transform 0.2s ease-in-out",
  ["--bs-accordion-btn-active-icon"]: `url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23${theme === "light" ? "052c65" : "ffffff"}%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e")`,
  ["--bs-accordion-btn-focus-box-shadow"]: "none",
  ["--bs-accordion-body-padding-x"]: "1.25rem",
  ["--bs-accordion-body-padding-y"]: "1rem",
  ["--bs-accordion-active-color"]: "none",
  ["--bs-accordion-active-bg"]: "none",
});

export const themeBasedPortfolioBtn = (theme) => ({
  ["--bs-btn-color"]: theme === "light" ? "var(--theme-light-primary)" : "rgb(222, 134, 228)",
  ["--bs-btn-bg"]: theme === "light" ? "rgb(248, 248, 248)" : "rgb(70, 70, 70)",
  ["--bs-btn-border-color"]: theme === "light" ? "rgb(195 209 226)" : "rgb(70, 70, 70)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.9)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "var(--theme-light-primary)" : "rgb(182, 111, 186)",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "var(--theme-light-primary)" : "rgb(182, 111, 186)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(87 147 221)" : "rgb(160, 97, 163)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(87 147 221)" : "rgb(182, 111, 186)",
});

export const themeBasedGoalFormControl = (theme) => ({
  ["--bs-body-color"]: theme === "light" ? "rgb(33, 37, 41)" : "rgb(237, 155, 242)",
  ["--bs-body-bg"]: theme === "light" ? "rgb(238, 242, 246)" : "rgb(50, 50, 50)",
  ["--bs-border-color"]: theme === "light" ? "rgb(185, 185, 185)" : "rgb(125, 125, 125)",
});

export const themeBasedPurchaseFormControl = (theme, error) => ({
  ["--bs-body-color"]: theme === "light" ? "rgb(41, 33, 35)" : "rgb(237, 155, 242)",
  ["--bs-body-bg"]: theme === "light" ? "rgb(239, 235, 242)" : "rgb(50, 50, 50)",
  ["--bs-border-color"]: theme === "light" ? "rgb(197, 211, 230)" : "rgb(125, 125, 125)",
});

export const themeBasedVerifyOtpModal = (theme) => ({
  ["--bs-body-color"]: theme === "light" ? "rgb(210, 210, 210)" : "rgb(237, 155, 242)",
  ["--bs-body-bg"]: theme === "light" ? "rgba(71, 98, 131, .82)" : "rgb(50, 50, 50)",
  ["--bs-border-color"]: theme === "light" ? "rgba(83, 120, 165, 0.82)" : "rgb(125, 125, 125)",
});

export const themeBasedPortfolioModalBtn = (theme) => ({
  ["--bs-btn-color"]: theme === "light" ? "rgba(0,0,0, 0.7)" : "rgba(255, 255, 255, .7)",
  ["--bs-btn-bg"]: theme === "light" ? "rgb(240, 240, 240)" : "rgb(100, 100, 100)",
  ["--bs-btn-border-color"]: theme === "light" ? "rgb(184, 186, 188)" : "rgb(100, 100, 100)",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(0,0,0, 0.9)" : "rgba(255, 255, 255, .8)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgb(188, 216, 245)" : "rgb(70, 70, 70)",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "rgb(100, 162, 238)" : "rgb(125, 125, 125)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(173, 202, 237)" : "rgb(181, 96, 186)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(100, 162, 238)" : "rgb(129, 66, 132)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
});

export const customPortfolioButton = {
  ["--bs-btn-color"]: "rgba(0,0,0, 0.7)",
  ["--bs-btn-bg"]: "rgb(240, 240, 240)",
  ["--bs-btn-border-color"]: "rgb(184, 186, 188)",
  ["--bs-btn-hover-color"]: "rgba(0,0,0, 0.9)",
  ["--bs-btn-hover-bg"]: "rgb(188, 216, 245)",
  ["--bs-btn-hover-border-color"]: "rgb(100, 162, 238)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(173, 202, 237)",
  ["--bs-btn-active-border-color"]: "rgb(100, 162, 238)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const customLoginButton = {
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "rgb(203, 108, 230)",
  ["--bs-btn-border-color"]: "rgb(140, 82, 255)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: "var(--theme-light-primary)",
  ["--bs-btn-hover-border-color"]: "rgb(32, 111, 206)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(32, 111, 206)",
  ["--bs-btn-active-border-color"]: "rgb(32, 111, 206)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const customRecoverButton = {
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "rgb(203, 108, 230)",
  ["--bs-btn-border-color"]: "rgb(140, 82, 255)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: "rgb(190, 100, 215)",
  ["--bs-btn-hover-border-color"]: "rgb(140, 82, 255)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(174, 93, 196)",
  ["--bs-btn-active-border-color"]: "rgb(140, 82, 255)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const customVerficationButton = (theme) => ({
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: theme === "light" ? "rgb(54, 125, 212)" : "rgb(203, 108, 230)",
  ["--bs-btn-border-color"]: theme === "light" ? "rgb(57, 131, 221)" : "rgb(140, 82, 255)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgb(51, 116, 196)" : "rgb(190, 100, 215)",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "rgb(51, 116, 196)" : "rgb(140, 82, 255)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(49, 112, 189)" : "rgb(174, 93, 196)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(45, 106, 180)" : "rgb(140, 82, 255)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
});

export const customModalCancelButton = {
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "rgb(100, 108, 122)",
  ["--bs-btn-border-color"]: "rgb(100, 108, 122)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: "rgb(120, 129, 145)",
  ["--bs-btn-hover-border-color"]: "rgb(100, 108, 122)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(100, 108, 121)",
  ["--bs-btn-active-border-color"]: "rgb(100, 108, 121)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const customCancelButton = {
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "var(--theme-light-primary)",
  ["--bs-btn-border-color"]: "rgb(32, 111, 206)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: "rgb(51, 122, 208)",
  ["--bs-btn-hover-border-color"]: "rgb(32, 111, 206)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(47, 113, 193)",
  ["--bs-btn-active-border-color"]: "rgb(32, 111, 206)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const customDangerButton = (theme = "dark") => ({
  ["--bs-btn-color"]: theme === 'dark' ? 'rgb(171, 155, 155)' : "rgba(255,255,255,0.7)",
  ["--bs-btn-bg"]: theme === 'dark' ? 'rgba(140, 28, 37, 0.2)' : "var(--theme-light-primary)",
  ["--bs-btn-border-color"]: theme === 'dark' ? 'rgba(122, 30, 38, 1)' : "rgb(32, 111, 206)",
  ["--bs-btn-hover-color"]: theme === 'dark' ? 'rgba(255,255,255,0.6)' : "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: theme === 'dark' ? 'rgba(140, 28, 37, 0.35)' : "rgb(51, 122, 208)",
  ["--bs-btn-hover-border-color"]: theme === 'dark' ? 'rgba(140, 28, 37, 0.35)' : "rgb(32, 111, 206)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: theme === 'dark' ? 'rgba(255,255,255,0.8)' : "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === 'dark' ? 'rgba(88, 23, 29, 0.45)' : "rgb(47, 113, 193)",
  ["--bs-btn-active-border-color"]: theme === 'dark' ? 'rgba(88, 23, 29, 0.45)' : "rgb(32, 111, 206)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
});

export const customSuccessButton = (theme = "dark") => ({
  ["--bs-btn-color"]: theme === 'dark' ? 'rgb(171, 155, 155)' : "rgba(255,255,255,0.7)",
  ["--bs-btn-bg"]: theme === 'dark' ? 'rgba(84, 101, 166, .2)' : "var(--theme-light-primary)",
  ["--bs-btn-border-color"]: theme === 'dark' ? 'rgba(84, 101, 166, .5)' : "rgb(32, 111, 206)",
  ["--bs-btn-hover-color"]: theme === 'dark' ? 'rgba(255,255,255,0.6)' : "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: theme === 'dark' ? 'rgba(84, 101, 166, .35)' : "rgb(51, 122, 208)",
  ["--bs-btn-hover-border-color"]: theme === 'dark' ? 'rgba(84, 101, 166, .35)' : "rgb(32, 111, 206)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: theme === 'dark' ? 'rgba(255,255,255,0.8)' : "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === 'dark' ? 'rgba(67, 81, 135, .35)' : "rgb(47, 113, 193)",
  ["--bs-btn-active-border-color"]: theme === 'dark' ? 'rgba(67, 81, 135, .35)' : "rgb(32, 111, 206)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
});

export const customTransactionHistoryButton = ({
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "rgb(37, 112, 226)",
  ["--bs-btn-border-color"]: "rgb(37, 112, 226)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-hover-bg"]: "rgb(187, 86, 195)",
  ["--bs-btn-hover-border-color"]: "rgb(187, 86, 195)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-active-bg"]: "rgb(173, 78, 180)",
  ["--bs-btn-active-border-color"]: "rgb(173, 78, 180)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(175, 95, 180, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
})

export const tabButton = (theme) => ({
  ["--bs-btn-color"]: theme === 'dark' ? "rgba(255, 255, 255, .8)" : "rgb(30, 41, 59)",
  ["--bs-btn-bg"]: theme === 'dark' ? "transparent" : "rgba(194, 215, 240, 1)",
  ["--bs-btn-border-color"]: theme === 'dark' ? "rgba(203, 110, 209, .8)" : "rgb(100, 162, 238)",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(0,0,0, 0.9)" : "rgba(255, 255, 255, .8)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgb(166 185 216)" : "rgba(203, 110, 209, .075)",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "rgb(66 92 133)" : "rgba(203, 110, 209, .6)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.9)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(55, 131, 223)" : "rgba(172, 91, 177, 1)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(55, 131, 223)" : "rgba(172, 91, 177, 1)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: theme === 'dark' ? "rgb(71 71 71)" : "rgb(56, 53, 62)",
  ["--bs-btn-disabled-border-color"]: theme === 'dark' ? "rgb(92, 90, 94)" : "rgb(56, 53, 62)",
});

export const categoryButton = (theme) => ({
  ["--bs-btn-color"]: theme === 'dark' ? "rgba(255, 255, 255, .6)" : "rgb(30, 41, 59)",
  ["--bs-btn-bg"]: theme === 'dark' ? "transparent" : "rgba(189, 195, 213, 1)",
  ["--bs-btn-border-color"]: theme === 'dark' ? "rgba(203, 110, 209, .6)" : "rgba(153, 172, 230, 1)",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(0,0,0, 0.9)" : "rgba(255, 255, 255, .8)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgb(166 185 216)" : "rgba(203, 110, 209, .075)",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "rgb(66 92 133)" : "rgba(203, 110, 209, .4)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(173, 202, 237)" : "rgba(203, 110, 209, .6)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(100, 162, 238)" : "rgba(203, 110, 209, .6)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: theme === 'dark' ? "rgba(41, 32, 57, 1)" : "rgb(56, 53, 62)",
  ["--bs-btn-disabled-border-color"]: theme === 'dark' ? "rgba(77, 56, 118, 1)" : "rgb(56, 53, 62)",
});

export const fundButton = (theme) => ({
  ["--bs-btn-color"]: theme === 'dark' ? "rgba(255, 255, 255, .6)" : "rgb(30, 41, 59)",
  ["--bs-btn-bg"]: theme === 'dark' ? "rgb(50, 50, 50)" : "transparent",
  ["--bs-btn-border-color"]: theme === 'dark' ? "rgba(91, 91, 91, 1)" : "rgba(153, 172, 230, 1)",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(0,0,0, 0.9)" : "rgba(255, 255, 255, .8)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgba(194, 215, 240, 1)" : "transparent",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "rgb(100, 162, 238)" : "rgba(203, 110, 209, .6)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: theme === 'dark' ? "rgba(255,255,255,0.8)" : 'rgb(30, 41, 59)',
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(173, 202, 237)" : "rgba(203, 110, 209, .075)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(100, 162, 238)" : "rgba(203, 110, 209, .4)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: theme === 'dark' ? "rgba(41, 32, 57, 1)" : "rgb(56, 53, 62)",
  ["--bs-btn-disabled-border-color"]: theme === 'dark' ? "rgba(77, 56, 118, 1)" : "rgb(56, 53, 62)",
});

export const stockTimeRangeButton = (theme) => ({
  ["--bs-btn-color"]: "rgba(255, 255, 255, .7)",
  ["--bs-btn-bg"]: theme === 'dark' ? "rgba(124, 90, 192, 1)" : "rgb(30, 41, 59)",
  ["--bs-btn-border-color"]: theme === 'dark' ? "rgba(113, 83, 173, 1)" : "rgb(30, 41, 59)",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(0,0,0, 0.9)" : "rgba(255, 255, 255, .8)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgb(166 185 216)" : "rgba(105, 76, 162, 1)",
  ["--bs-btn-hover-border-color"]: theme === "light" ? "rgb(66 92 133)" : "rgb(129, 94, 198)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgb(173, 202, 237)" : "rgba(124, 90, 192, 1)",
  ["--bs-btn-active-border-color"]: theme === "light" ? "rgb(100, 162, 238)" : "rgba(124, 90, 192, 1)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: theme === 'dark' ? "rgba(41, 32, 57, 1)" : "rgb(56, 53, 62)",
  ["--bs-btn-disabled-border-color"]: theme === 'dark' ? "rgba(77, 56, 118, 1)" : "rgb(56, 53, 62)",
});

export const fundBackLink = (theme) => ({
  ["--bs-btn-color"]: theme === 'dark' ? "rgb(203, 110, 209)" : "rgb(41, 124, 223)",
  ["--bs-btn-bg"]: "none",
  ["--bs-btn-border-color"]: "none",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(0,0,0, 0.9)" : "rgba(255, 255, 255, .7)",
  ["--bs-btn-hover-bg"]: "none",
  ["--bs-btn-hover-border-color"]: "none",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "none",
  ["--bs-btn-active-border-color"]: "none",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
});

export const customPortfolioModalButton = {
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "rgb(13, 110, 253)",
  ["--bs-btn-border-color"]: "rgb(13, 110, 253)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: "var(--theme-light-secondary)",
  ["--bs-btn-hover-border-color"]: "var(--theme-light-primary)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(175, 95, 180)",
  ["--bs-btn-active-border-color"]: "rgb(175, 95, 180)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(175, 95, 180, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const customAcceptButton = {
  ["--bs-btn-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-bg"]: "rgb(22, 120, 74)",
  ["--bs-btn-border-color"]: "rgb(22, 120, 74)",
  ["--bs-btn-hover-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-hover-bg"]: "rgb(25, 133, 83)",
  ["--bs-btn-hover-border-color"]: "rgb(25, 133, 83)",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: "rgb(22, 120, 74)",
  ["--bs-btn-active-border-color"]: "rgb(22, 120, 74)",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(175, 95, 180, 0.125)",
  ["--bs-btn-disabled-color"]: "rgba(255,255,255,0.7)",
  ["--bs-btn-disabled-bg"]: "rgb(86, 86, 86)",
  ["--bs-btn-disabled-border-color"]: "rgb(73, 73, 73)",
};

export const themeBasedSignupFormControl = (theme) => ({
  ["--bs-body-bg"]: theme === "dark" ? "rgb(230, 230, 230)" : "rgb(107, 106, 138)",
  ["--bs-body-color"]: theme === "dark" ? "#212529" : "rgba(240, 240, 240, .95)",
  ["--bs-border-color"]: theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
});

export const themeBasedPagination = (theme) => ({
  ["--bs-pagination-padding-x"]: ".85rem",
  ["--bs-pagination-bg"]: theme === "dark" ? "rgba(59, 59, 59, 0.7)" : "rgba(238, 238, 238, 0.9)",
  ["--bs-pagination-color"]: theme === "dark" ? "var(--theme-light-secondary)" : "",
  ["--bs-pagination-border-color"]: theme === "dark" ? "rgba(80, 80, 80, 0.7)" : "rgba(75, 75, 75, 0.6)",
  ["--bs-pagination-focus-bg"]: theme === "dark" ? "rgb(179, 99, 185)" : "",
  ["--bs-pagination-focus-color"]: theme === "dark" ? "#fff" : "",
  ["--bs-pagination-focus-box-shadow"]: theme === "dark" ? "0 0 .2rem 0.15rem rgba(124, 124, 124, 0.25)" : "",
  ["--bs-pagination-active-bg"]: theme === "dark" ? "rgb(179, 99, 185)" : "",
  ["--bs-pagination-active-border-color"]: theme === "dark" ? "rgba(131, 131, 131, 0.7)" : "",
  ["--bs-pagination-hover-bg"]: theme === "dark" ? "rgba(49, 49, 49, 0.7)" : "rgba(97, 97, 97, 0.7)",
  ["--bs-pagination-hover-border-color"]: theme === "dark" ? "rgba(80, 80, 80, 0.7)" : "rgba(75, 75, 75, 0.6)",
  ["--bs-pagination-hover-color"]: theme === "dark" ? "rgba(180, 180, 180, 0.7)" : "rgba(0,0,0,.8)",
  ["--bs-pagination-disabled-bg"]: theme === "dark" ? "rgba(80, 80, 80, 0.7)" : "rgb(203, 203, 203)",
  ["--bs-pagination-disabled-border-color"]: theme === "dark" ? "rgba(80, 80, 80, 0.7)" : "rgba(137, 137, 137, .6)",
  ["--bs-pagination-disabled-color"]: theme === "dark" ? "rgba(130, 130, 130)" : "rgb(131, 131, 131)",
});

export const themeBasedGlossaryButton = (activeGlossaryIndex, theme, letter) => ({
  ["--bs-btn-color"]: activeGlossaryIndex === letter ? "rgba(255,255,255,.9)" : theme === "light" ? "rgba(0,0,0,.6)" : "rgba(255,255,255,.8)",
  ["--bs-btn-bg"]: activeGlossaryIndex === letter ? (theme === "light" ? "rgb(0,0,0,.7)" : "var(--theme-light-secondary)") : "none",
  ["--bs-btn-border-color"]: "none",
  ["--bs-btn-hover-color"]: theme === "light" ? "rgba(255,255,255, 0.9)" : "rgba(255,255,255, 0.9)",
  ["--bs-btn-hover-bg"]: theme === "light" ? "rgba(0,0,0,.7)" : "var(--theme-light-secondary)",
  ["--bs-btn-hover-border-color"]: "none",
  ["--bs-btn-focus-shadow-rgb"]: "32, 111, 206",
  ["--bs-btn-active-color"]: "rgba(255,255,255,0.8)",
  ["--bs-btn-active-bg"]: theme === "light" ? "rgba(0,0,0,.5)" : "var(--theme-light-secondary)",
  ["--bs-btn-active-border-color"]: "none",
  ["--bs-btn-active-shadow"]: "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
});

export const mobilePagination = {
  ["--bs-pagination-padding-x"]: ".75rem",
  ["--bs-pagination-font-size"]: ".85rem",
  ["--bs-pagination-padding-y"]: ".35rem",
};
